import { Injectable } from '@angular/core';
import { interval } from 'rxjs/internal/observable/interval';
import { timer } from 'rxjs/internal/observable/timer';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
	providedIn: 'root',
})
export class DocsTimerManagerService {
	public totalTime: number = 0;
	public warningTime: number = 0;
	public takePhotoTime: number = 0;

	private subsTotalTime: Subscription;
	private subsWarningTime: Subscription;
	private subsMaxTime: Subscription;
	private subsTakePhotoTime: Subscription;

	// Total Time
	public startTotalTime(): void {
		if (!this.subsTotalTime) {
			this.subsTotalTime = this.createTimer(() => this.totalTime++);
		}
	}
	public stopTotalTime(): void {
		if (this.subsTotalTime) {
			this.subsTotalTime.unsubscribe();
			this.subsTotalTime = null;
		}
	}
	public resetTotalTime(): void {
		this.totalTime = 0;
	}

	// Warning Time
	public startWarningTime(fn: () => void): void {
		if (!this.subsWarningTime) {
			this.subsWarningTime = this.createTimer(() => {
				this.warningTime++;
				fn();
			});
		}
	}
	public stopWarningTime(): void {
		if (this.subsWarningTime) {
			this.subsWarningTime.unsubscribe();
			this.subsWarningTime = null;
		}
		this.warningTime = 0;
	}

	// Max Time
	public startMaxTime(fn: () => void, maxTimeMilliseconds: number): void {
		if (!this.subsMaxTime) {
			this.subsMaxTime = timer(maxTimeMilliseconds).subscribe(() => {
				fn();
				this.stopMaxTime();
			});
		}
	}
	public stopMaxTime(): void {
		if (this.subsMaxTime) {
			this.subsMaxTime.unsubscribe();
			this.subsMaxTime = null;
		}
	}

	// Take Photo Time
	public startTakePhotoTime(fn: () => void): void {
		if (!this.subsTakePhotoTime) {
			this.subsTakePhotoTime = this.createTimer(() => {
				this.takePhotoTime++;
				fn();
			});
		}
	}
	public stopTakePhotoTime(): void {
		if (this.subsTakePhotoTime) {
			this.subsTakePhotoTime.unsubscribe();
			this.subsTakePhotoTime = null;
		}
		this.takePhotoTime = 0;
	}

	// Utilidad para crear timer
	private createTimer(callback: () => void): Subscription {
		// Usar timer de RxJS para incrementar cada segundo
		return interval(1000).subscribe(callback);
	}
}
